var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
 * Copyright (c) 2019-present Sonatype, Inc.
 * This program and the accompanying materials are made available under
 * the terms of the Eclipse Public License 2.0 which accompanies this
 * distribution and is available at https://www.eclipse.org/legal/epl-2.0/.
 */
import React from 'react';
import classnames from 'classnames';
import { propTypes } from './types';
import NxButton from '../NxButton/NxButton';
import NxFontAwesomeIcon from '../NxFontAwesomeIcon/NxFontAwesomeIcon';
import { faCaretLeft, faCaretRight } from '@fortawesome/free-solid-svg-icons';
export { propTypes };
export default function NxIndeterminatePagination(_a) {
    var className = _a.className, onPrevPageSelect = _a.onPrevPageSelect, onNextPageSelect = _a.onNextPageSelect, attrs = __rest(_a, ["className", "onPrevPageSelect", "onNextPageSelect"]);
    var classes = classnames('nx-btn-bar', 'nx-btn-bar--pagination', className);
    return (React.createElement("nav", __assign({ tabIndex: 0, "aria-label": "pagination", className: classes }, attrs),
        React.createElement(NxButton, { "aria-label": "previous page", onClick: onPrevPageSelect, variant: "tertiary" },
            React.createElement(NxFontAwesomeIcon, { icon: faCaretLeft })),
        React.createElement(NxButton, { "aria-label": "next page", onClick: onNextPageSelect, variant: "tertiary" },
            React.createElement(NxFontAwesomeIcon, { icon: faCaretRight }))));
}
NxIndeterminatePagination.propTypes = propTypes;
//# sourceMappingURL=NxIndeterminatePagination.js.map